import {
  ExportJobDocsDestinationResult,
  ExportJobResult,
  ExportJobStatus,
  ExporterDestinationAzure,
  ExporterDestinationBitbucket,
  ExporterDestinationDocs,
  ExporterDestinationGithub,
  ExporterDestinationGitlab,
  ExporterDestinationS3,
  ObjectMeta,
} from "@supernova-studio/model";
import { z } from "zod";
import { DTOExporterPropertyValueMap } from "./exporter-property";

export const DTOExportJobCreatedBy = z.object({
  userId: z.string(),
  userName: z.string(),
});

export const DTOExportJobDesignSystemPreview = z.object({
  id: z.string(),
  meta: ObjectMeta,
});

export const DTOExportJobDesignSystemVersionPreview = z.object({
  id: z.string(),
  meta: ObjectMeta,
  version: z.string(),
  isReadonly: z.boolean(),
});

export const DTOExportJobDestinations = z.object({
  s3: ExporterDestinationS3.optional(),
  azure: ExporterDestinationAzure.optional(),
  bitbucket: ExporterDestinationBitbucket.optional(),
  github: ExporterDestinationGithub.optional(),
  gitlab: ExporterDestinationGitlab.optional(),
  documentation: ExporterDestinationDocs.optional(),
  webhookUrl: z.string().optional(),
});

export const DTOExportJobResult = ExportJobResult.omit({
  sndocs: true,
}).extend({
  documentation: ExportJobDocsDestinationResult.optional(),
});

export const DTOExportJob = z.object({
  id: z.string(),

  createdAt: z.coerce.date(),
  finishedAt: z.coerce.date().optional(),

  index: z.number().optional(),
  status: ExportJobStatus,
  estimatedExecutionTime: z.number().optional(),

  createdBy: DTOExportJobCreatedBy.optional(),
  designSystem: DTOExportJobDesignSystemPreview,
  designSystemVersion: DTOExportJobDesignSystemVersionPreview,

  destinations: DTOExportJobDestinations,

  exporterId: z.string(),
  scheduleId: z.string().optional(),

  result: DTOExportJobResult.optional(),

  brandPersistentId: z.string().optional(),
  themePersistentId: z.string().optional(),
  themePersistentIds: z.string().array().optional(),

  exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
});

export const DTOExportJobResponse = z.object({
  job: DTOExportJob,
});

// Deprecated: Use only for test purposes and extend if only necessary. This defines the BE response for an export job.
export const DTOExportJobResponseLegacy = z.object({
  job: z.object({
    id: z.string(),
    status: ExportJobStatus,
  }),
});

export type DTOExportJobResponseLegacy = z.infer<typeof DTOExportJobResponseLegacy>;
export type DTOExportJobCreatedBy = z.infer<typeof DTOExportJobCreatedBy>;
export type DTOExportJobDesignSystemPreview = z.infer<typeof DTOExportJobDesignSystemPreview>;
export type DTOExportJobDesignSystemVersionPreview = z.infer<typeof DTOExportJobDesignSystemVersionPreview>;
export type DTOExportJobDestinations = z.infer<typeof DTOExportJobDestinations>;
export type DTOExportJobResult = z.infer<typeof DTOExportJobResult>;
export type DTOExportJob = z.infer<typeof DTOExportJob>;
export type DTOExportJobResponse = z.infer<typeof DTOExportJobResponse>;

//
// Write
//

export const DTOExportJobCreateInput = z.object({
  designSystemId: z.string(),
  designSystemVersionId: z.string(),
  exporterId: z.string(),
  brandId: z.string().optional(),
  themeId: z.string().optional(),
  themePersistentIds: z.string().array().optional(),
  destinations: DTOExportJobDestinations,
  exporterPropertyValues: DTOExporterPropertyValueMap.optional(),
  previewMode: z.boolean().optional(),
});

export type DTOExportJobCreateInput = z.infer<typeof DTOExportJobCreateInput>;
